import Image, { ImageProps } from 'next/image';
import { HTMLAttributeAnchorTarget, MouseEvent } from 'react';

import { IntrinsicElement } from '../../../../shared/utilities/types/IntrinsicElement';
import { RATIO, Ratio } from '../../ratio/Ratio';
import { Typography } from '../../typography/Typography';

import style from './FacetCard.module.css';

type FacetCardSize = 'default' | 'small';

const PICTURE_RATIO: Record<FacetCardSize, number> = {
    default: RATIO['3/4'],
    small: RATIO['16/9'],
};

interface FacetCardProps {
    href: string;
    image: ImageProps;
    target?: HTMLAttributeAnchorTarget;
    title: string;
    size?: FacetCardSize;
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
    titleElement?: IntrinsicElement;
}

export function FacetCard({
    href,
    image,
    target,
    title,
    size = 'default',
    onClick,
    titleElement = 'span',
}: FacetCardProps) {
    return (
        <div className={style.card}>
            <Ratio ratio={PICTURE_RATIO[size]} className={style.imageRatio}>
                <Image {...image} alt={image.alt} fill className={style.image} />
            </Ratio>
            <a onClick={onClick} className={style.link} href={href} target={target}>
                <Typography as={titleElement} scale="primary-body-bold" className={style.title}>
                    {title}
                </Typography>
            </a>
        </div>
    );
}

FacetCard.PICTURE_RATIO = PICTURE_RATIO;
